export enum CargoMartPlansType {
  FREE = 'FREE',
  TRIAL = 'TRIAL',
  MONTHLY_TRIAL = 'MONTHLY_TRIAL',
  PRO = 'PRO',
}
